import { render, staticRenderFns } from "./PostingBosReportTab.vue?vue&type=template&id=2912340e"
import script from "./PostingBosReportTab.vue?vue&type=script&lang=js"
export * from "./PostingBosReportTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports